"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const style_sheet_1 = __importDefault(require("./utils/style-sheet"));
const styleSheet = new style_sheet_1.default({});
styleSheet.inject();
function add(styles) {
    styleSheet.insert(styles);
}
exports.add = add;
function getAll() {
    // Convert rules array to a string
    return styleSheet
        .rules()
        .reduce((combinedRules, rule) => combinedRules + rule.cssText, '');
}
exports.getAll = getAll;
function clear() {
    styleSheet.flush();
    styleSheet.inject();
}
exports.clear = clear;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHNFQUE0QztBQUU1QyxNQUFNLFVBQVUsR0FBRyxJQUFJLHFCQUFVLENBQUMsRUFBRSxDQUFDLENBQUE7QUFDckMsVUFBVSxDQUFDLE1BQU0sRUFBRSxDQUFBO0FBRW5CLFNBQWdCLEdBQUcsQ0FBQyxNQUFjO0lBQ2hDLFVBQVUsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUE7QUFDM0IsQ0FBQztBQUZELGtCQUVDO0FBRUQsU0FBZ0IsTUFBTTtJQUNwQixrQ0FBa0M7SUFDbEMsT0FBTyxVQUFVO1NBQ2QsS0FBSyxFQUFFO1NBQ1AsTUFBTSxDQUFDLENBQUMsYUFBcUIsRUFBRSxJQUF5QixFQUFFLEVBQUUsQ0FBQyxhQUFhLEdBQUcsSUFBSSxDQUFDLE9BQU8sRUFBRSxFQUFFLENBQUMsQ0FBQTtBQUNuRyxDQUFDO0FBTEQsd0JBS0M7QUFFRCxTQUFnQixLQUFLO0lBQ25CLFVBQVUsQ0FBQyxLQUFLLEVBQUUsQ0FBQTtJQUNsQixVQUFVLENBQUMsTUFBTSxFQUFFLENBQUE7QUFDckIsQ0FBQztBQUhELHNCQUdDIn0=